import { h } from 'preact';
import { useState } from 'preact/hooks';
import { TabBar } from '../TabBar';
import type { ComponentShowcase } from '../registry';
import { T } from '../../../styles/tokens';

function TabBarShowcaseWrapper() {
  const [active, setActive] = useState('t2');
  return (
    <div>
      <TabBar
        tabs={[
          { id: 't1', label: 'Geral' },
          { id: 't2', label: 'Pendentes', badge: 5 },
          { id: 't3', label: 'Configurações' },
        ]}
        active={active}
        onChange={setActive}
      />
      <div style={{ color: T.textMuted, fontSize: 13, marginTop: 8 }}>Aba ativa: {active}</div>
    </div>
  );
}

export const showcase: ComponentShowcase = {
  name: 'TabBar',
  category: '🗂️ Navegação',
  description: 'Barra de abas com badge numérico e estado ativo',
  usedIn: ['ReferralDashboard', 'AffiliatesPanel', 'AdminDesignSystem'],
  example: () => <TabBarShowcaseWrapper />,
};
